import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-progress-indicator',
  templateUrl: './progress-indicator.component.html',
  styleUrls: ['./progress-indicator.component.css']
})
export class ProgressIndicatorComponent {

  INDICATOR_TYPE_BAR = 'PROGRESS_BAR';
  INDICATOR_TYPE_SPINNER = 'PROGRESS_SPINNER';

  @Input() inProgress: boolean;
  @Input() indicatorType: string = this.INDICATOR_TYPE_BAR;
  @Input() progressText: string = 'Lade Daten...';

}
